module.exports = __webpack_public_path__ + "img/Globe.1ade728c.png";